export default class FilterableAccordion {
    constructor(el) {
        
        this.widget = el
        this.filter = el.querySelector("[id=sections-filter]")
        this.accordion = el.querySelectorAll(".c-filterable-accordion-section")
        this.tab = el.querySelectorAll(".c-filterable-accordion-tab")

        this.addEventListeners()
        this.animateSection()
    }

    addEventListeners() {
        this.filter.addEventListener("change", (event) => {
            // Get the selected value
            const selectedValue = event.target.value;

            this.filterValues(selectedValue);
        })
        
        this.tab.forEach(item => { 
            item.addEventListener("click", (event) => {
                this.accordion.forEach(item => {
                    item.style.removeProperty('--height');
                });
                
                setTimeout(() => {
                    this.animateSection();
                }, 500);
            })
        });
    }

    filterValues(value) {
        this.accordion.forEach(item => {
            item.style.removeProperty('--height');

            if (value === '*' || value === item.dataset.filter) {
                item.classList.remove('show', 'hide');
                item.classList.add('show');
            } else {
                item.classList.remove('show', 'hide');
                item.classList.add('hide');
            }
        });

        setTimeout(() => {
            this.animateSection();
        }, 600);
    }
    
    animateSection() {
        this.accordion.forEach(item => { 
            item.style.setProperty('--height', `${item.offsetHeight}px`);
        })
    }
}
